export default __webpack_public_path__ + "static/media/desiredJob.0d05cf5e.svg";